/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { DRAWER_EDITOR_QUERY_PARAMS } from 'embercom/services/knowledge-hub-drawer-editor-service';
import type { EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';

export default class ConfigurationAgentController extends Controller {
  @service declare router: RouterService;

  queryParams = [
    ...DRAWER_EDITOR_QUERY_PARAMS,
    'proposalChatId',
    'proposalUuid',
    'proposalEntityType',
    'proposalEntityId',
  ];

  // Knowledge hub drawer editor query params
  @tracked activeContentId?: number;
  @tracked activeContentType?: string;
  @tracked editorMode?: EditorMode;
  @tracked collectionId?: string;
  @tracked contentLocale?: string;
  @tracked folderId?: string;

  // Proposal drawer query params
  @tracked proposalChatId: string | null = null;
  @tracked proposalUuid: string | null = null;
  @tracked proposalEntityType: string | null = null;
  @tracked proposalEntityId: string | null = null;

  get isProposalDrawerOpen(): boolean {
    return (
      this.proposalChatId !== null &&
      this.proposalUuid !== null &&
      this.proposalEntityType !== null &&
      this.proposalEntityId !== null
    );
  }

  @action
  closeProposalDrawer(): void {
    this.router.transitionTo({
      queryParams: {
        proposalChatId: null,
        proposalUuid: null,
        proposalEntityType: null,
        proposalEntityId: null,
      },
    });
  }
}
